export default {
  "Altstadt": {
    description: "As the historical center of Frankfurt, the Altstadt has existed from Frankfurt's beginnings, dating back to 794. It used to be part of the original Innenstadt area, which lay inside of the city walls. The Altstadt contains many of Frankfurt's most important sights.",
    rentUrl: "https://www.immobilienscout24.de/Suche/S-T/Wohnung-Miete/Hessen/Frankfurt-am-Main/Altstadt?enteredFrom=one_step_search",
  },
  "Nordend ": {
    description: "As a whole, the Nordend is the second largest district by population in Frankfurt after Sachsenhausen. The Nordend is popular for its bohemian mix of restaurants, cafés and bars.",
    rentUrl: "https://www.immobilienscout24.de/Suche/S-T/Wohnung-Miete/Hessen/Frankfurt-am-Main/Nordend-West?enteredFrom=one_step_search",
  },
  "Bergen-Enkheim": {
    description: "Bergen-Enkheim were first mentioned as a common village in the thirteenth century. The two locations were administered together for centuries in 1936, but Bergen-Enkheim only officially became a town in 1968. In 1977 it was incorporated into the city of Frankfurt.",
    rentUrl: "https://www.immobilienscout24.de/Suche/S-T/Wohnung-Miete/Hessen/Frankfurt-am-Main/Bergen-Enkheim?enteredFrom=one_step_search",
  },
  "Niederrad": {
    description: "The district is mainly designated as residential area. Niederrad is the site of the western part of the University Hospital Frankfurt, Frankfurt naming of some important institutions.",
    rentUrl: "hhttps://www.immobilienscout24.de/Suche/S-T/Wohnung-Miete/Hessen/Frankfurt-am-Main/Niederrad?enteredFrom=one_step_search",
  },
};



// WEBPACK FOOTER //
// ./src/data/districtsInfo.js